module.exports = __webpack_public_path__ + "static/media/ttgr_thumb_home_2.b287c0aa.mp4";